// import global from '@/assets/js/global'
// import axios from 'axios'
import resources from '@/assets/js/resources'
import store from '@/store/index'
import { ElLoading, ElMessage } from 'element-plus'
import typeList from '../../../static/data.json'
import quillConfig from '@/assets/js/quillConfig'
let loadingInstance = null
import { Base64 } from 'js-base64';
import CryptoJS from 'crypto-js';
let secretKey = 'BwkLGbyfTiyij3QG9si5FCozqeC4FaK5hDvPsIANpkM02zjBn1z3+svtISsDbPHV0d4KxCKzzySAwLdQA3PuDA=='
// 获取本地存储
function getStorage(key, type) {
  if (sessionStorage.getItem(key)) {
    if (store.state.storageData[key]) {
      return store.state.storageData[key];
    } else {
      let data = {}
      let obj = {}
      data = sessionStorage.getItem(key);
      try {
        // 使用 AES 解密
        let bytes = CryptoJS.AES.decrypt(data, secretKey);
        let encryptedText = bytes.toString(CryptoJS.enc.Utf8);
        obj = JSON.parse(encryptedText)
        if (key === 'users') {
          if (obj.name) {
            obj.name = Base64.decode(obj.name) ? Base64.decode(obj.name) : obj.name;
          }
          if (obj.idCard) {
            obj.idCard = Base64.decode(obj.idCard) ? Base64.decode(obj.idCard) : obj.idCard;
          }
        }
        store.state.storageData[key] = obj
        return obj
      } catch (error) {
        console.log(error)
        return {}
      }
    }
  }
  return {}

}
// 设置本地存储
function setStorage(data, key, type) {
  if (data) {
    let text = JSON.stringify(data)
    try {
      let encryptedText = CryptoJS.AES.encrypt(text, secretKey).toString();
      sessionStorage.setItem(key, encryptedText)
    } catch (error) {
      console.error('加密失败:', error);
    }
  }


}
export default {
  getTypeListFn(e) {
    return typeList[e]
  },
  statusFn(s, m, d) {
    switch (s) {
      case 401:
        if (m === 'login') {
          ElMessage.error(d)
        } else {
          ElMessage.error('登录超时请重新登录')
        }

        break
      case 403:
        ElMessage.error('暂无' + m + '权限')
        break
      case 502:
        ElMessage.error('服务器正在维护中，请稍后再试')
        break
      case 503:
        ElMessage.error('服务器正在维护中，请稍后再试')
        break
      case 507:
        ElMessage.error(m + '失败')
        break
      default:
        ElMessage.error(m + '失败')
    }
  },
  //系统类型转换
  sysTypeConvert(e, arr) {
    if (!e || !e.length) {
      return ''
    }
    if (!arr || !arr.length) {
      return ''
    }
    let valueList = e
    if (!Array.isArray(e)) {
      valueList = e.split(',')
    }

    const objArrret = []
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < valueList.length; j++) {
        if (valueList[j] === arr[i].value) {
          objArrret.push(arr[i].text)
        }
      }
    }
    return objArrret.join(',')
  },
  // 资源类型
  menuType() {
    return [{ text: '菜单' }, { text: '功能' }, { text: '网页外部' }, { text: '网页内部' }, { text: '待建设' }, { text: '领导驾舱' }, { text: 'AI小助手' }, { text: '其他' }]
  },

  // 获取本地存储
  getStorage(key, type) {
    return getStorage(key, type)
  },
  // 设置本地存储
  setStorage(data, key, type) {
    return setStorage(data, key, type)
  },
  buttonShowFn(code) {
    const users = this.getStorage('users');
    if (users) {
      return users.roles.includes(code)
    }
  },
  editorOption() {
    return quillConfig.editorOption
  },
  quillInit() {
    return quillConfig.quillInit()
  },
  getSysViewPage(key) {
    const data = sessionStorage.getItem('sysViewPage')
    if (data) {
      const obj = JSON.parse(data)
      if (key && obj[key]) {
        return obj[key]
      } else {
        return false
      }
    } else {
      return false
    }
  },
  // 列表排序
  listSort(list, sortkey, type, searchKey, searchvalue) {
    // list 需要排序数据，sortkey排序字段名，type 1倒序2正序，searchKey搜索字段名，searchvalue搜索内容
    if (!list) {
      return []
    }
    const arr = list.filter((item) => {
      return String(item[searchKey]).indexOf(searchvalue) !== -1
    })
    if (type) {
      arr.sort((a, b) => {
        return type === 1 ? b[sortkey] - a[sortkey] : a[sortkey] - b[sortkey]
      })
    }
    return arr
  },
  getTableStyleObj() {
    const result = {
      rowStyle: { height: '10px' },
      headerRowStyle: { height: '10px' },
      cellStyle: { padding: '7px 0 5px 0' },
      headerCellStyle: { padding: '5px 0' }
    }
    return result
  },
  tenantCodeSplit(e) {
    if (e.length > 6) {
      return e.slice(0, 6)
    } else {
      return e
    }
  },
  // 全局loading事件
  openFullScreen(options) {
    let obj = {
      fullscreen: true,
      text: 'loading',
      background: 'rgba(0, 0, 0, 0.7)'
    }
    if (options) {
      obj = Object.assign(obj, {}, options)
    }
    // eslint-disable-next-line no-const-assign
    loadingInstance = ElLoading.service(obj)
  },
  // 关闭全局loading事件
  closeFullScreen() {
    // Loading should be closed asynchronously
    loadingInstance.close()
  },
  // 设置浏览器图标
  getCreate(url) {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url
    document.getElementsByTagName('head')[0].appendChild(link);
  },
  // JSON数据转换
  gettypeListLabelFn(e, e1) {
    if (e1 === '' || e1 === null || e1 === undefined) {
      return ''
    } else {
      if (String(e1).indexOf(',') !== -1) {
        const objArr = e1.split(',')
        const objArrret = []
        for (let i = 0; i < typeList[e].length; i++) {
          for (let j = 0; j < objArr.length; j++) {
            if (objArr[j] === typeList[e][i].value) {
              objArrret.push(typeList[e][i].text)
            }
          }
        }
        return objArrret.join(',')
      } else {
        for (let i = 0; i < typeList[e].length; i++) {
          if (e1 === typeList[e][i].value) {
            return typeList[e][i].text
          }
        }
      }
    }
  },
  // 数据字典转换
  transformationFn(arr, e) {
    if (!arr) {
      return ''
    }
    if (e === '' || e === null || e === undefined) {
      return ''
    } else {
      if (String(e).indexOf(',') !== -1) {
        const objArr = e.split(',')
        const objArrret = []
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < objArr.length; j++) {
            if (objArr[j] === arr[i].value) {
              objArrret.push(arr[i].label)
            }
          }
        }
        return objArrret.join(',')
      } else {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].value === String(e)) {
            return arr[i].label
          }
        }
      }
    }
  },
  // 生成随机数
  generateRandom() {
    return Math.random().toString(16).slice(2);
  },
  cloneDeep(data) {
    // string,number,bool,null,undefined,symbol
    // object,array,date
    if (data && typeof data === 'object') {
      // 针对函数的拷贝
      if (typeof data === 'function') {
        const tempFunc = data.bind(null)
        tempFunc.prototype = this.cloneDeep(data.prototype)
        return tempFunc
      }
      // 根据不同的数据类型的深拷贝
      switch (Object.prototype.toString.call(data)) {
        case '[object String]':
          return data.toString()
        case '[object Number]':
          return Number(data.toString())
        case '[object Boolean]':
          // eslint-disable-next-line no-new-wrappers
          return new Boolean(data.toString())
        case '[object Date]':
          return new Date(data.getTime())
        case '[object Array]':
          // eslint-disable-next-line no-case-declarations
          const arr = []
          for (let i = 0; i < data.length; i++) {
            arr[i] = this.cloneDeep(data[i])
          }
          return arr

        // js自带对象或用户自定义类实例
        case '[object Object]':
          // eslint-disable-next-line no-case-declarations
          const obj = {}
          for (const key in data) {
            // 会遍历原型链上的属性方法，可以用hasOwnProperty来控制 （obj.hasOwnProperty(prop)
            obj[key] = this.cloneDeep(data[key])
          }
          return obj
      }
    } else {
      // string,number,bool,null,undefined,symbol
      return data
    }
  },
  getDictionarys(e, dictionarys) {
    let arr = []
    if (dictionarys && dictionarys.length) {
      const list = dictionarys.filter((item) => item.type === e)
      arr = list.length ? list[0].content : []
    }
    return arr
  },
  // 在线预览
  previewFileEvent(e, title) {
    const fileUrl = e.url;
    store.state.previewImageShow = true;
    store.state.previewImageUrl = fileUrl;
    store.state.previewImageType = fileUrl.substr(fileUrl.lastIndexOf(".") + 1);
    store.state.previewImageTitle = title || '';
    store.state.previewImageFullscreen = false;
  },
  quillContentFileter(e) {
    if (!e) {
      return ''
    }
    return e === '<p><br></p>' ? '' : e
  },
  validateBase64(str) {
    // eslint-disable-next-line prefer-regex-literals
    const imgReg = RegExp(/data:image\/.*;base64,/);
    const res = imgReg.test(str);
    return res;
  },
  // 导出
  exportsFn(name, data) {
    const blob = new Blob([data]);
    const link = document.createElement("a");
    link.download = name;
    link.href = URL.createObjectURL(blob);
    link.click();
  },
  // 请求头  content-disposition 提取文件名
  getContentdisposition(e) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
      e["content-disposition"]
    );
    return decodeURI(matches[1].replace(/['"]/g, ""));
  },
  // 下载二维码
  downImg(name, type, imgUrl) {
    // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
    if (window.navigator.msSaveOrOpenBlob) {
      const bstr = atob(imgUrl.split(',')[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      const blob = new Blob([u8arr])
      window.navigator.msSaveOrOpenBlob(blob, name + '.' + type)
    } else {
      // 这里就按照chrome等新版浏览器来处理
      const a = document.createElement('a')
      a.href = imgUrl
      a.setAttribute('download', name)
      a.click()
    }
  },
  // 获取所有省
  getprovinces() {
    const arr = resources.chinaList.provinces
    return arr
  },
  // 获取市
  getcities(v) {
    const arr = resources.chinaList.cities
    const arr2 = []
    arr.forEach((item, index) => {
      if (item.provinceCode === v) {
        arr2.push(item)
      }
    })
    return arr2
  },
  // 获取县（区）
  getareas(v) {
    const arr = resources.chinaList.areas
    const arr2 = []
    arr.forEach((item, index) => {
      if (item.cityCode === v) {
        arr2.push(item)
      }
    })
    return arr2
  },
  // 获取镇
  getstreets(v) {
    const arr = resources.chinaList.streets
    const arr2 = []
    arr.forEach((item, index) => {
      if (item.areaCode === v) {
        arr2.push(item)
      }
    })
    return arr2
  },
  getvillage(v) {
    const arr = resources.chinaList.streets
    const obj = {
      provinceCode: null,
      cityCode: null,
      areaCode: null,
      streetCode: v
    }
    arr.forEach((item, index) => {
      if (item.code === v) {
        obj.provinceCode = item.provinceCode
        obj.cityCode = item.cityCode
        obj.areaCode = item.areaCode
      }
    })
    return obj
  },
  // 内容中图片视频设置
  htmlFn(e, imgStyle, videoStyle) {
    if (!e) { return '' }
    // eslint-disable-next-line no-unneeded-ternary
    const iStyle = imgStyle ? imgStyle : 'width:80%'
    // eslint-disable-next-line no-unneeded-ternary
    const vStyle = videoStyle ? videoStyle : 'width:80%'
    let content = e.replace(
      // eslint-disable-next-line no-useless-escape
      /<img[\s\S]*?src\s*=\s*[\"|\'](.*?)[\"|\'][\s\S]*?>/g,
      function (match, capture) {
        return (
          "<img style='" + iStyle + "' src='" +
          capture +
          "'/>"
        )
      }
    )
    content = content.replace(
      // eslint-disable-next-line no-useless-escape
      /<video[\s\S]*?src\s*=\s*[\"|\'](.*?)[\"|\'][\s\S]*?>/g,
      function (match, capture) {
        return (
          "<video controls=\"controls\" type=\"video/mp4\" style='" + vStyle + "' src='" +
          capture +
          "'/>"
        )
      }
    )
    return content
  },
  // 递归数据
  createTreeData(list, parentId, pcodeString, codeString) {
    const arr = []
    let tempObj
    if (list.length > 0) {
      if (pcodeString && codeString) {
        list.forEach((item, index) => {
          if (item[pcodeString] === parentId) {
            const treeItem = item
            tempObj = this.createTreeData(
              list,
              item[codeString],
              pcodeString,
              codeString
            )
            if (tempObj.length > 0) {
              if (treeItem.children) {
                treeItem.children.push(...tempObj)
              } else {
                treeItem.children = tempObj
              }
            }
            arr.push(treeItem)
          }
        })
      } else {
        list.forEach((item, index) => {
          if (item.pcode === parentId) {
            const treeItem = item
            tempObj = this.createTreeData(list, item.code)
            if (tempObj.length > 0) {
              treeItem.children = tempObj
            }
            arr.push(treeItem)
          }
        })
      }
    }
    return arr
  },
  async copyText(text) {
    // 优先使用Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {
        // 失败降级到dom方案
      }
    }
    // 降级兼容方案
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  },
}


export { getStorage, setStorage }